import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsProcessType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSProcessPoints = ({ process }: { process?: CMSOpportunityDetailsProcessType }) => {
  return (
    <CmsSectionText className='opportunity-cms-section-process' dataTestId='cms-process-content'>
      <ul className='basic connected-list'>
        {process?.points?.map((point, idx) => (
          <li key={idx}>
            <RichTextRenderer content={point?.blockText} />
          </li>
        ))}
      </ul>
    </CmsSectionText>
  )
}

export { CMSProcessPoints }
